import { TextField, styled } from "@mui/material";

const DialogTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    position: "relative",
    top: "-12px",
    left: "-8px",
    backgroundColor: "white",
    paddingRight: "5px",
  },
  "& .MuiFilledInput-root": {
    borderRadius: "0px",
    backgroundColor: "theme.palette.grey[50]",
  },
  "& .MuiInputBase-input": {
    paddingTop: "10px", // Adjust this value as needed to center the text vertically
    paddingBottom: "10px", // Adjust this value as needed to center the text vertically
  },
});

export const DialogNumberField = styled(DialogTextField)({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
})

export const DialogMultilineTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    position: "relative",
    top: "-12px",
    left: "-8px",
    backgroundColor: "white",
    paddingRight: "5px",
  },
  "& .MuiFilledInput-root": {
    borderRadius: "0px",
    backgroundColor: "theme.palette.grey[50]",
  },
  "& .MuiInputBase-input": {
    marginTop: "-10px",
  },
});

export const DialogAutoCompleteTextField = styled(TextField)({
    "& .MuiInputLabel-root": {
      position: "relative",
      top: "-0px",
      left: "-8px",
      backgroundColor: "white",
      paddingRight: "5px",
      shrink: false,
      textTransform: 'uppercase',
      color: "black",
      fontSize: "1.00rem",
      fontWeight: "600"
    },
    "& .MuiFilledInput-root": {
      borderRadius: "0px",
      backgroundColor: "theme.palette.grey[50]",
    },
    "& .MuiInputBase-input": {
      paddingTop: "10px", // Adjust this value as needed to center the text vertically
      paddingBottom: "10px", // Adjust this value as needed to center the text vertically
    },
  });
  
export default DialogTextField;
